// extracted by mini-css-extract-plugin
export default {"classGroupEditForm":"classGroupEditForm-lpjhs","groupFormBody":"groupFormBody-qWnIa"};